import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {ListEmisorComponent} from './cmp-list-emisor/list-emisor.component';
import {FormEmisorComponent} from './cmp-form-emisor/form-emisor.component';
import {CardEmisorComponent} from './cmp-card-emisor/card-emisor.component';
import {CardHoverDirective} from './recursos/directive/card-hover.directive';
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {ScrollEventModule} from 'ngx-scroll-event';
import {NgStringPipesModule} from '../../../../../pipes/string/index';
import {CmpComplementosComponent} from './cmp-complementos/cmp-complementos.component';
import {CmpConfPseComponent} from './cmp-conf-pse/cmp-conf-pse.component';
import {CmpConfDocumentosComponent} from './cmp-conf-documentos/cmp-conf-documentos.component';
import {CmpConfAplicatiavoComponent} from './cmp-conf-aplicatiavo/cmp-conf-aplicatiavo.component';
import {MaterialModule} from '../../../../material.module';
import {UsuarioModule} from '../usuario/usuario.module';
import {PrettyJsonModule} from 'angular2-prettyjson';
import {MomentModule} from 'angular2-moment';
import {LoadingModule} from '../../../../autenticacion/loadingScreen/loading.module';
import {HelperFormEmisorComponent} from './cmp-form-emisor/helper/helperFormEmisor.component';
import {CmpConfSeriesComponent} from './cmp-conf-series/cmp-conf-series.component';
import {MatButtonModule, MatExpansionModule, MatIconModule, MatInputModule, MatTableModule} from '@angular/material';
import {CmpStockProductsComponent} from './cmp-conf-stock-productos/cmp-conf-stock-productos.component';
import {CdkTableModule} from '@angular/cdk/table';
import {CurrencyMaskModule} from 'ng2-currency-mask';
import {CmpReceiverComponent} from './cmp-conf-receiver/cmp-conf-receiver.component';
import {Ng2SmartTableModule} from 'ng2-smart-table';
import {CmpConfAdicionalComponent} from './cmp-conf-adicional/cmp-conf-adicional.component';
import {ColorPickerComponent} from '../../../shared/color-picker/color-picker.component';
import {NuevoProductoComponent} from './cmp-nuevo-producto/nuevo-producto.component';
import {NuevoReceptorComponent} from './cmp-nuevo-receptor/nuevo-receptor.component';
import {NumericDirective} from '../../../recursos/directive/numeric-directive.directive';
import {CmpGREPointsComponent} from './cmp-conf-gre-points/cmp-conf-gre-points.component';
import {CmpGRECarrierComponent} from './cmp-conf-gre-carrier/cmp-conf-gre-carrier.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        BrowserAnimationsModule,
        NoopAnimationsModule,
        NgStringPipesModule,
        ScrollEventModule,
        UsuarioModule,
        MaterialModule,
        MomentModule,
        PrettyJsonModule,
        LoadingModule,
        MatTableModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        CdkTableModule,
        CurrencyMaskModule,
        MatExpansionModule,
        Ng2SmartTableModule,
    ],
    declarations: [
        ListEmisorComponent,
        FormEmisorComponent,
        CardEmisorComponent,
        CardHoverDirective,
        CmpComplementosComponent,
        CmpConfPseComponent,
        CmpConfDocumentosComponent,
        CmpConfAplicatiavoComponent,
        CmpConfSeriesComponent,
        CmpStockProductsComponent,
        CmpReceiverComponent,
        CmpGREPointsComponent,
        CmpGRECarrierComponent,
        CmpConfAdicionalComponent,
        HelperFormEmisorComponent,
        ColorPickerComponent,
        NuevoProductoComponent,
        NumericDirective,
        NuevoReceptorComponent],
    exports: [
        NuevoProductoComponent,
        NuevoReceptorComponent,
        NumericDirective,
    ]
})
export class EmisorModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/emisor.module.ts